import { useEffect, useState } from "react"

const { Snackbar } = require("@material-ui/core")
const { Alert, AlertTitle } = require("@material-ui/lab")

export const ErrorPop = ({error, setError, timeout}) => {

    const [timeo, setTo] = useState(8000)
    useEffect(() => {        
        if (timeout != undefined) {
            setTo(timeout)
        }
    },  [])
    return (
        <Snackbar
            open={error != null}
            autoHideDuration={timeo}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            onClose={() => setError(null)}
        >
            <Alert
                onClose={() => setError(null)}
                severity="error"
                variant="filled"
                sx={{ width: '100%' }}
            >
                <AlertTitle>Whoa!</AlertTitle>
                {error}
            </Alert>

        </Snackbar>
    )

}
